import { render, staticRenderFns } from "./complex_multipleChoiceShare_dialog.vue?vue&type=template&id=195d5c52"
import script from "./complex_multipleChoiceShare_dialog.vue?vue&type=script&lang=js"
export * from "./complex_multipleChoiceShare_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports